import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LiveChatWidgetComponent } from "../../shared/components/live-chat-widget/live-chat-widget.component";

@Component({
  selector: 'logibids-main',
  standalone: true,
  imports: [RouterOutlet, LiveChatWidgetComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
 


}
